import { get, post } from "@/utils/request";
import type { Response } from "../types/axios";

export const getRoutes = (): Promise<Response> => post("/api/menu/list");

//获取鉴权token
export const GetTokenByTicket = (params: string): Promise<Response> =>
  post(`/api/Staff/GetTokenByTicket/${params}`);

//待我审批
export const GetCurrentMyPageList = () =>
  post("/api/approvalManagement/getApprovePendingRequest");

//公用撤回组件
export const RecallFlow = (params: {
  Id: number | string;
  Description: string;
}) => post("/api/companyFlow/recallFlow", params);

//公用下载组件
// export const downloadFile = (params: {
//   fileKey: string;
// }) => post(`api/file/downLoad/${fileKey}`, params);

//公用预览组件
export const previewFile = (fileKey: string) => {
  return get(`/api/template/preview/${fileKey}`);
};
